import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { ToastService } from './toast.service';
import { DialogService } from '@progress/kendo-angular-dialog';

@Injectable({providedIn: 'root'})
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private toastService: ToastService, private dialogService: DialogService) { }
  canDeactivate(component: ComponentCanDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
      if (this.toastService.isActive) {
        this.displayDialog();
        return false;
      }
      return component.canDeactivate();
  }
  displayDialog() {
    this.dialogService.open({
      title: 'Leaving Page',
      content: 'Please close the error message in order to proceed.',
      actions: [
        { text: 'OK', primary: true },
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });
  }
}
